/*
 * @Descripttion:
 * @version:
 * @Author: 付正生
 * @Date: 2022-06-20 17:43:51
 * @LastEditors: James chen
 * @LastEditTime: 2022-07-01 10:39:38
 */
export const tanRouter = [
  {
    path: "/salesContractDetails",
    name: "salesContractDetails",
    component: () => import("@/views/salesManagement/salesContract/salesContractDetails"),
    meta: { title: "生产订单详情", keepAlive: false },
  },
  {
    path: "/distribute",
    name: "distribute",
    component: () => import("@/views/planManage/proOrder/distribute"),
    meta: { title: "派发至车间", keepAlive: false },
  },
  {
    path: "/workshopPlanDetail",
    name: "workshopPlanDetail",
    component: () => import("@/views/planManage/workshopPlan/detail"),
    meta: { title: "计划详情", keepAlive: false },
  },
  {
    path: "/workshopPlanAdd",
    name: "workshopPlanAdd",
    component: () => import("@/views/planManage/workshopPlan/add"),
    meta: { title: "手动排产", keepAlive: false },
  },
  {
    path: "/stockCheckForm",
    name: "stockCheckForm",
    component: () => import("@/views/warehouseManagement/stockCheck/stockCheckForm"),
    meta: { title: "新建盘点单", keepAlive: false },
  },
  {
    path: "/inventoryOrderForm",
    name: "inventoryOrderForm",
    component: () => import("@/views/warehouseManagement/inventoryOrder/inventoryOrderForm"),
    meta: { title: "新建入库单", keepAlive: false },
  },
  {
    path: "/inventoryOrderDetail",
    name: "inventoryOrderDetail",
    component: () => import("@/views/warehouseManagement/inventoryOrder/inventoryOrderDetail"),
    meta: { title: "入库单详情", keepAlive: false },
  },
  {
    path: "/newReportForm",
    name: "newReportForm",
    component: () => import("@/views/workManagement/productTask/newReportForm"),
    meta: { title: "新建报工", keepAlive: false },
  },
  {
    path: "/outboundOrderForm",
    name: "outboundOrderForm",
    component: () => import("@/views/warehouseManagement/outboundOrder/outboundOrderForm"),
    meta: { title: "新建出库单", keepAlive: false },
  },
  {
    path: "/outboundOrderDetail",
    name: "outboundOrderDetail",
    component: () => import("@/views/warehouseManagement/outboundOrder/outboundOrderDetail"),
    meta: { title: "出库单详情", keepAlive: false },
  },
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () => import("@/views/workManagement/productTask/reportDetail"),
    meta: { title: "报工详情", keepAlive: false },
  },
  {
    path: "/productTask/taskDetail",
    name: "productTaskTaskDetail",
    component: () => import("@/views/workManagement/productTask/taskDetail"),
    meta: { title: "任务详情", keepAlive: false },
  },
  {
    path: "/editInspectionTaskForm",
    name: "editInspectionTaskForm",
    component: () => import("@/views/quality/qualityInspectionTask/edit"),
    meta: { title: "质检任务编辑", keepAlive: false },
  },
  // edit
  {
    path: "/inspectionRecordForm",
    name: "inspectionRecordForm",
    component: () => import("@/views/quality/qualityInspectionTask/inspectionRecordForm"),
    meta: { title: "检验汇报", keepAlive: false },
  },
  {
    path: "/qualityInspectionTaskDetail",
    name: "qualityInspectionTaskDetail",
    component: () => import("@/views/quality/qualityInspectionTask/detail"),
    meta: { title: "质检任务详情", keepAlive: false },
  },
  {
    path: "/qualityInspectionDetail",
    name: "qualityInspectionDetail",
    component: () => import("@/views/quality/qualityInspectionRecord/detail"),
    meta: { title: "检验详情", keepAlive: false },
  },
  {
    path: "/disqualificationTreatmentForm",
    name: "disqualificationTreatmentForm",
    component: () => import("@/views/quality/disqualificationTreatment/form"),
    meta: { title: "处理", keepAlive: false },
  },
  {
    path: "/disqualificationTreatmentDetail",
    name: "disqualificationTreatmentDetail",
    component: () => import("@/views/quality/disqualificationTreatment/detail"),
    meta: { title: "不合格处理详情", keepAlive: false },
  },
  {
    path: "/workOrderForm",
    name: "workOrderForm",
    component: () => import("@/views/workManagement/workOrder/form"),
    meta: { title: "报检", keepAlive: false },
  },
]
